import { render, staticRenderFns } from "./riskAssessmentForm.vue?vue&type=template&id=80ddb096&scoped=true"
import script from "./riskAssessmentForm.vue?vue&type=script&lang=js"
export * from "./riskAssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./riskAssessmentForm.vue?vue&type=style&index=0&id=80ddb096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ddb096",
  null
  
)

export default component.exports